var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.588,
    height: 18.295,
    viewBox: "0 0 20.588 18.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#45517a;stroke:rgba(0,0,0,0);stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.816,17.3A.778.778,0,0,1,0,16.565V10.809a.692.692,0,0,1,.024-.175l.005-.018L2.3,4.207a.8.8,0,0,1,.788-.544H7.315a.437.437,0,0,1,.437.436v.588a.438.438,0,0,1-.437.437H3.71L1.887,10.079H6.441a.815.815,0,0,1,.769.486l.554,1.411h4.061l.555-1.411a.815.815,0,0,1,.769-.486H17.7L15.879,5.124H12.273a.437.437,0,0,1-.436-.437V4.1a.437.437,0,0,1,.436-.436H16.5a.8.8,0,0,1,.788.544l2.275,6.427a.631.631,0,0,1,.023.175v5.756a.777.777,0,0,1-.814.73Zm.814-1.461H17.959v-4.3H13.725l-.554,1.411a.814.814,0,0,1-.768.487H7.187a.814.814,0,0,1-.768-.487l-.554-1.411H1.63Zm7.8-5.883a.974.974,0,0,1-.32-.2L7.171,7.812A.972.972,0,0,1,8.546,6.437l.28.291V.967a.968.968,0,0,1,1.936,0V6.73l.281-.291.006-.006a.966.966,0,0,1,1.368.006l0,0,.006.006a.968.968,0,0,1-.006,1.369L10.48,9.748a.955.955,0,0,1-.319.2.915.915,0,0,1-.734,0Z",
    transform: "translate(0.5 0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1518834024807cfea119a849d181f17d.svg";
export { ForwardRef as ReactComponent };